module.exports = {
      id: "pinterest-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "svg-sprite-39dbc991ee8a2ec1b35aeef6495011e2.svg#pinterest",
      toString: function () {
        return this.url;
      }
    }